import { getInstance } from "./axiosFactory";
import { raiseError } from "./globalActions";
import { saveState } from "../store/LocalStorage";
import { get } from "lodash";
import Swal from "sweetalert2";
const axiosInstance = getInstance();

export function loginSuccess(loginResult) {
	return { type: "LOGIN_SUCCESSFUL", loginResult };
}

export function loginFailure(failure) {
	return { type: "LOGIN_FAILURE", failure };
}

export function logoutAction() {
	return { type: "LOGOUT" };
}

export const login = (username, Upassword, setLoading) => {
	console.log("the login", username, Upassword, axiosInstance);

	setLoading(true); // ✅ disable button and show loader

	axiosInstance
		.post("/login", {
			username: username,
			Upassword: Upassword
		})
		.then((res) => {

			// ✅ Step 1: Check if backend says 2FA is required
			if (res.data.require2FA === true) {

				Swal.fire({
					html: `
						<h2 style="font-size: 20px !important; font-weight: 600; margin-bottom: 5px;">Two-Factor Authentication</h2>
						<p style="font-size: 14px; color: #666; margin-bottom: 15px;">
							Please enter the 6-digit code sent to your email.
						</p>
						<input type="text" id="twoFactorCode" class="swal2-input" placeholder="Enter 2FA Code">
					`,
					showConfirmButton: true,
					confirmButtonText: "Verify",
					confirmButtonColor: "rgb(21, 189, 140)",
					didRender: () => {
						const btn = document.querySelector(".swal2-confirm");
						if (btn) {
							btn.style.color = "white";
							btn.style.fontWeight = "600";
						}
					},
					focusConfirm: false,
					showLoaderOnConfirm: true,

					preConfirm: async () => {
						try {
							const code = document.getElementById("twoFactorCode").value;
							if (!code) {
								Swal.showValidationMessage("Please enter the code");
								return false;
							}

							const verifyRes = await axiosInstance.post("/verify-2fa", {
								userId: res.data.userId,
								code: code,
							});

							return verifyRes.data;

						} catch (err) {
							if (err.response && err.response.status === 400) {
								Swal.showValidationMessage(err.response.data.message || "Invalid code. Please try again");
							} else {
								Swal.showValidationMessage("Something went wrong. Try again.");
							}
							return false;
						}
					},
				}).then((result) => {

					if (result.isConfirmed && result.value) {

						const verifyData = result.value;

						saveState({
							auth: { ...verifyData, loggedIn: true },
						});

						localStorage.setItem("isAuthenticated", "true");
						localStorage.setItem("URole", verifyData.responce[0].role);
						localStorage.setItem("ManegerId", verifyData.responce[0].Id);

						window.location.href = "/";
					}

					setLoading(false);  // ✅ re-enable button if 2FA window closes without confirm
				});

				return; // ✅ stop here
			}

			// ✅ Step 4: NO 2FA → normal login
			saveState({ auth: { ...get(res, "data"), loggedIn: true } });

			if (res.data.responce[0].status === "LoggedIn") {

				localStorage.setItem("isAuthenticated", "true");
				localStorage.setItem("URole", res.data.responce[0].role);
				localStorage.setItem("ManegerId", res.data.responce[0].Id);

				window.location.href = "/";
			} else {
				Swal.fire({
					title: "Error",
					text: "Not Authorized User",
					icon: "error",
					confirmButtonText: "Ok",
				});
				setLoading(false); // ✅ login failed → enable button
			}

		})
		.catch(error => {
			console.log("error occur", error);
			setLoading(false); // ✅ enable button on error
		});
};

export const forgetPasswordAction = (emailAddress) => {
	return axiosInstance.post("account/forgetPassword", { emailAddress });
}

export const resetPasswordAction = (newPassword, resetToken) => {
	return axiosInstance.post("account/resetPassword", { newPassword, resetToken });
}

export const resetPasswordURLVisitAction = (resetToken) => {
	return axiosInstance.post("account/resetpasswordurlvisitentry", { resetToken });
}

export const logout = () => {
	return dispatch => {
		localStorage && localStorage.setItem('keepMeLogin', false);
		saveState({});
		dispatch(logoutAction());
	}
}